import {
	IconCalendar,
	IconClipboardText,
	IconNumber123,
} from "@tabler/icons-react";
import { format } from "date-fns";
import type { Workspace } from "@/common/model";
import { IdField } from "@/components/base";
import { BaseDetails, EditableText } from "@/components/base-details";

interface WorkspaceDetailsProps {
	workspace?: Workspace;
	onSaveName?: (value: string) => void;
}

/** Read-only or editable detail view for a single workspace. */
export function WorkspaceDetails({
	workspace,
	onSaveName,
}: WorkspaceDetailsProps) {
	if (!workspace) return null;
	return (
		<BaseDetails
			item={workspace}
			fields={[
				{
					key: "id",
					tooltip: "Id",
					icon: IconNumber123,
					render: (id) => <IdField id={id as string} showCopyButton />,
				},
				{
					key: "name",
					tooltip: "Name",
					icon: IconClipboardText,
					render: (name) => (
						<EditableText onChange={onSaveName}>{name as string}</EditableText>
					),
				},
				{
					key: "createdAt",
					tooltip: "Created",
					icon: IconCalendar,
					render: (createdAt) =>
						format(new Date(createdAt as string), "MM/dd/yyyy h:mm a"),
				},
			]}
		/>
	);
}
